import React, { useEffect } from "react";
import {
  consumeApi,
  getTokens,
  setLiteral,
  validateEmail,
} from "../js/helpers.js";
import Framework7, { Dom7, getDevice } from "framework7";
import ContactInformation from "./contactInformation.jsx";
import ReferenciaUnica from "./referenciaUnica";
import parse from "html-react-parser";
import { capital, specialChar, digit } from "../js/password.js";
import {
  Page,
  f7,
  Navbar,
  NavLeft,
  Link,
  LoginScreen,
  AccordionContent,
  Block,
  NavRight,
  Panel,
  View,
  Button,
  BlockFooter,
  ListItem,
  Row,
  Col,
  LoginScreenTitle,
  List,
  ListInput,
  ListButton,
  Icon,
  Swiper,
  SwiperSlide,
  Popup,
  BlockTitle,
} from "framework7-react";

import packageJson from "../../package.json";
import ReferenciaUnicaConekta from "./referenciaUnicaConekta.jsx";

export default class HomePage extends React.Component {
  render() {
    return (
      <Page name="home" className="mainImg">
        {/* Top Navbar */}
        <Navbar>
          <NavLeft>
            <div className="Logo"></div>
          </NavLeft>
          <NavRight style={{ paddingRight: "20px" }}>
            <Link className="linkHome" onClick={(e) => this.selectTab(e, 1)}>
              {setLiteral(this.state.lsLiterales, 101001)}
            </Link>
            <Link className="linkHome" onClick={(e) => this.selectTab(e, 2)}>
              {setLiteral(this.state.lsLiterales, 101002)}
            </Link>
            <Link className="linkHome" onClick={(e) => this.selectTab(e, 3)}>
              {setLiteral(this.state.lsLiterales, 101003)}
            </Link>
            <Link className="linkHome" onClick={(e) => this.selectTab(e, 4)}>
              {setLiteral(this.state.lsLiterales, 101004)}
            </Link>
            <Link
              className="linkHome"
              onClick={() => {
                this.setState({ loginScreenOpened: true });
              }}
            >
              {setLiteral(this.state.lsLiterales, 101005).replace(
                "<i class='fa fa-user'></i> ",
                ""
              )}
            </Link>
            {/* <Link className="linkHome" onClick={this.dialogsignIn}>LOGIN</Link> */}
            <Link
              className="linkMenu"
              id="linkMenu"
              iconIos="f7:menu"
              iconAurora="f7:menu"
              iconMd="material:menu"
              panelOpen="#panel-right"
            />
          </NavRight>
        </Navbar>
        <Panel right cover containerEl="#home" id="panel-right">
          <View>
            <Page>
              <Block className="menuPanel">
                <li>
                  <Link
                    className="linkPanelMenu"
                    panelClose
                    onClick={(e) => this.selectTab(e, 1)}
                  >
                    {setLiteral(this.state.lsLiterales, 101001)}
                  </Link>
                </li>
                <li>
                  <Link
                    className="linkPanelMenu"
                    panelClose
                    onClick={(e) => this.selectTab(e, 2)}
                  >
                    {setLiteral(this.state.lsLiterales, 101002)}
                  </Link>
                </li>
                <li>
                  <Link
                    className="linkPanelMenu"
                    panelClose
                    onClick={(e) => this.selectTab(e, 3)}
                  >
                    {setLiteral(this.state.lsLiterales, 101003)}
                  </Link>
                </li>
                <li>
                  <Link
                    className="linkPanelMenu"
                    panelClose
                    onClick={(e) => this.selectTab(e, 4)}
                  >
                    {setLiteral(this.state.lsLiterales, 101004)}
                  </Link>
                </li>
                <li>
                  <Link
                    className="linkPanelMenu"
                    panelClose
                    onClick={() => {
                      this.setState({ loginScreenOpened: true });
                    }}
                  >
                    {setLiteral(this.state.lsLiterales, 101005).replace(
                      "<i class='fa fa-user'></i> ",
                      ""
                    )}
                  </Link>
                </li>
                {/* <li><Link className="linkPanelMenu" onClick={this.dialogsignIn}>{setLiteral(this.state.lsLiterales, 101005)}</Link></li> */}
              </Block>
            </Page>
          </View>
        </Panel>
        {this.renderSection(this.state.selectedTab)}

        {/* POPUP LOGIN */}

        <Popup
          opened={this.state.loginScreenOpened}
          onPopupClosed={() => this.setState({ loginScreenOpened: false })}
        >
          <Page>
            <Navbar title={setLiteral(this.state.lsLiterales, 101023)}>
              <NavRight>
                <Link
                  id="closeLogin"
                  popupClose
                  className={this.state.closeLogin}
                >
                  X
                </Link>
              </NavRight>
            </Navbar>
            <Block>
              <List form>
                <Row className="aligner">
                  <Col
                    width="90"
                    xlarge="65"
                    large="65"
                    medium="65"
                    small="90"
                    xsmall="90"
                  >
                    <ListInput
                      outline
                      label={setLiteral(this.state.lsLiterales, 101024)}
                      floatingLabel
                      type="text"
                      // maxlength="15"
                      onChange={(e) =>
                        this.setState({ username: e.target.value })
                      }
                      value={this.state.username}
                      //onChange={(e) => this.changeUser(e.target.value.toUpperCase())}
                      //onBlur={(e) => this.changeUser(e.target.value.toUpperCase())}
                    >
                      <Icon
                        icon="person_alt_circle_fill"
                        f7="person_alt_circle_fill"
                        size="35"
                        slot="media"
                      />
                    </ListInput>
                  </Col>
                  <Col width="10"></Col>
                </Row>
                <Row className="aligner">
                  <Col
                    width="90"
                    xlarge="65"
                    large="65"
                    medium="65"
                    small="90"
                    xsmall="90"
                  >
                    <ListInput
                      outline
                      label={setLiteral(this.state.lsLiterales, 101025)}
                      floatingLabel
                      onChange={(e) =>
                        this.setState({ password: e.target.value })
                      }
                      type="password"
                      id="passwordLogin"
                      name="passwordLogin"
                    >
                      <Icon
                        icon="lock_fill"
                        f7="lock_fill"
                        size="35"
                        slot="media"
                      />
                    </ListInput>
                  </Col>
                  <Col width="10">
                    <Button
                      id="btnShowPass"
                      iconF7="eye_slash"
                      size="10"
                      onClick={() =>
                        this.showPassword("passwordLogin", "btnShowPass")
                      }
                    ></Button>
                  </Col>
                </Row>
                <Block>
                  <Row className="aligner">
                    <Col width="30">
                      <Button
                        fill
                        onClick={async () =>
                          this.validateUser(
                            this.state.username,
                            this.state.password
                          )
                        }
                      >
                        {setLiteral(this.state.lsLiterales, 101027)}
                      </Button>
                    </Col>
                  </Row>
                </Block>
              </List>
              <List>
                <BlockFooter>
                  <Row className="aligner">
                    <Col
                      width="100"
                      xlarge="50"
                      large="50"
                      medium="50"
                      small="100"
                      xsmall="100"
                    >
                      <ListButton onClick={this.showChangePass}>
                        {setLiteral(this.state.lsLiterales, 101026)}
                      </ListButton>
                    </Col>
                  </Row>
                  <Row className="aligner">
                    <Col
                      width="100"
                      xlarge="50"
                      large="50"
                      medium="50"
                      small="100"
                      xsmall="100"
                    >
                      <ListButton
                        onClick={(e) => {
                          e.preventDefault();
                          this.setState({
                            popupRegistro: true,
                            loginScreenOpened: false,
                          });
                        }}
                      >
                        {setLiteral(this.state.lsLiterales, 101028)}
                      </ListButton>
                    </Col>
                  </Row>
                </BlockFooter>
              </List>
            </Block>
          </Page>
        </Popup>

        {/* POPUP REGISTRO */}

        <Popup
          className="demo-popup"
          opened={this.state.popupRegistro}
          onPopupClosed={() => this.setState({ popupRegistro: false })}
        >
          <Page>
            <Navbar title={setLiteral(this.state.lsLiterales, 101062)}>
              <NavRight>
                <Link popupClose>X</Link>
              </NavRight>
            </Navbar>
            <Block>
              <BlockTitle>
                {parse(setLiteral(this.state.lsLiterales, 101063))}
              </BlockTitle>
              <Block>
                <Row className="aligner">
                  <Col width="33" className="aligner">
                    <Icon f7="doc_person" size="50" />
                  </Col>
                  <Col width="33" className="aligner">
                    <Icon f7="lock_open_fill" size="50" />
                  </Col>
                  <Col width="33" className="aligner">
                    <Icon f7="device_phone_portrait" size="50" />
                  </Col>
                </Row>
                <Row className="aligner">
                  <Col width="33" className="textCenter">
                    {parse(setLiteral(this.state.lsLiterales, 101064))}
                  </Col>
                  <Col width="33" className="textCenter">
                    {setLiteral(this.state.lsLiterales, 101065)}
                  </Col>
                  <Col width="33" className="textCenter">
                    {parse(setLiteral(this.state.lsLiterales, 101066))}
                  </Col>
                </Row>
                <Row className="aligner">
                  <Col
                    width="90"
                    xlarge="50"
                    large="50"
                    medium="50"
                    small="90"
                    xsmall="90"
                  >
                    <List noHairlinesMd>
                      <ListInput
                        outline
                        label={setLiteral(this.state.lsLiterales, 101067)}
                        floatingLabel
                        type="text"
                        placeholder={setLiteral(this.state.lsLiterales, 101068)}
                        clearButton
                        pattern="[0-9 a-z A-Z]*"
                        validate
                        required
                        onChange={(e) =>
                          this.setState({ Identification: e.target.value })
                        }
                        value={this.state.Identification}
                        id="inIdentification"
                      ></ListInput>
                    </List>
                  </Col>
                </Row>
                <Row className="aligner">
                  <Col
                    width="35"
                    xlarge="25"
                    large="25"
                    medium="25"
                    small="35"
                    xsmall="35"
                  >
                    <Button
                      fill
                      onClick={() => this.setState({ popupRegistro: false })}
                    >
                      {setLiteral(this.state.lsLiterales, 101071)}
                    </Button>
                  </Col>
                  <Col width="30"></Col>
                  <Col
                    width="35"
                    xlarge="25"
                    large="25"
                    medium="25"
                    small="35"
                    xsmall="35"
                  >
                    <Button
                      fill
                      onClick={(e) => this.validateIdentification(e)}
                    >
                      {setLiteral(this.state.lsLiterales, 101070)}
                    </Button>
                  </Col>
                </Row>
                <BlockTitle
                  className={
                    setLiteral(this.state.lsLiterales, 101072) == "OCULTO"
                      ? "hide"
                      : ""
                  }
                >
                  {parse(setLiteral(this.state.lsLiterales, 101072))}
                </BlockTitle>
                <List
                  accordionList
                  inset
                  className={
                    setLiteral(this.state.lsLiterales, 101073) == "OCULTO"
                      ? "hide"
                      : ""
                  }
                >
                  <ListItem
                    accordionItem
                    title={setLiteral(this.state.lsLiterales, 101073)}
                  >
                    <AccordionContent>
                      <Block>
                        {parse(setLiteral(this.state.lsLiterales, 101074))}
                      </Block>
                    </AccordionContent>
                  </ListItem>
                  <ListItem
                    accordionItem
                    title={setLiteral(this.state.lsLiterales, 101075)}
                  >
                    <AccordionContent>
                      <Block>
                        <p>
                          {parse(setLiteral(this.state.lsLiterales, 101076))}
                        </p>
                        <p>
                          {parse(setLiteral(this.state.lsLiterales, 101077))}
                        </p>
                      </Block>
                    </AccordionContent>
                  </ListItem>
                  <ListItem
                    accordionItem
                    title={setLiteral(this.state.lsLiterales, 101078)}
                  >
                    <AccordionContent>
                      <Block>
                        <p>
                          {parse(setLiteral(this.state.lsLiterales, 101079))}
                        </p>
                        <ul className="">
                          <li>
                            {parse(setLiteral(this.state.lsLiterales, 101080))}
                          </li>
                          <br />
                          <li>
                            {parse(setLiteral(this.state.lsLiterales, 101081))}
                          </li>
                          <br />
                          <li>
                            {parse(setLiteral(this.state.lsLiterales, 101082))}
                          </li>
                          <br />
                          <li>
                            {parse(setLiteral(this.state.lsLiterales, 101083))}
                          </li>
                          <br />
                          <li>
                            {parse(setLiteral(this.state.lsLiterales, 101084))}
                          </li>
                          <br />
                          <li>
                            {parse(setLiteral(this.state.lsLiterales, 101085))}
                          </li>
                          <br />
                          <li>
                            {parse(setLiteral(this.state.lsLiterales, 101086))}
                          </li>
                        </ul>
                      </Block>
                    </AccordionContent>
                  </ListItem>
                </List>
              </Block>
            </Block>
          </Page>
        </Popup>

        {/* POPUP REGISTRO USUARIO */}

        <Popup
          className="demo-popup"
          opened={this.state.popupUser}
          onPopupClosed={() => this.setState({ popupUser: false })}
        >
          <Page>
            <Navbar
              title={
                setLiteral(this.state.lsLiterales, 101092) +
                " " +
                this.state.userInformation.full_name
              }
            >
              <NavRight>
                <Link popupClose>X</Link>
              </NavRight>
            </Navbar>
            <Block>
              <Block>
                <BlockTitle className="textCenter">
                  {parse(setLiteral(this.state.lsLiterales, 101093))}
                </BlockTitle>
                <List noHairlinesMd>
                  <Row className="aligner">
                    <Col
                      width="90"
                      xlarge="65"
                      large="65"
                      medium="65"
                      small="90"
                      xsmall="90"
                    >
                      <ListInput
                        outline
                        label={setLiteral(this.state.lsLiterales, 101036)}
                        floatingLabel
                        type="text"
                        maxlength="10"
                        // onChange={(e) => this.changeUser(e.target.value)}
                        autocomplete="false"
                        value={this.state.hideEmail}
                        disabled
                      >
                        <Icon
                          icon="person_alt_circle_fill"
                          f7="person_alt_circle_fill"
                          size="35"
                          slot="media"
                        />
                      </ListInput>
                    </Col>
                    <Col width="10"></Col>
                  </Row>
                  <Row className="aligner">
                    <Col
                      width="90"
                      xlarge="65"
                      large="65"
                      medium="65"
                      small="90"
                      xsmall="90"
                    >
                      <ListInput
                        outline
                        label={setLiteral(this.state.lsLiterales, 101037)}
                        floatingLabel
                        onChange={this.validatePassword}
                        type="password"
                        name="password"
                      >
                        <Icon
                          icon="lock_fill"
                          f7="lock_fill"
                          size="35"
                          slot="media"
                        />
                      </ListInput>
                    </Col>
                    <Col width="10">
                      <Button
                        id="btnShowPassRegister"
                        iconF7="eye_slash"
                        size="10"
                        onClick={() =>
                          this.showPassword("password", "btnShowPassRegister")
                        }
                      ></Button>
                    </Col>
                  </Row>
                  <Row className="aligner">
                    <Col
                      width="90"
                      xlarge="65"
                      large="65"
                      medium="65"
                      small="90"
                      xsmall="90"
                    >
                      <ListInput
                        outline
                        label={setLiteral(this.state.lsLiterales, 101039)}
                        floatingLabel
                        validate
                        onChange={this.validateSamePass}
                        type="password"
                      >
                        <Icon
                          icon="lock_fill"
                          f7="lock_fill"
                          size="35"
                          slot="media"
                        />
                      </ListInput>
                    </Col>
                    <Col width="10"></Col>
                    <Col id="samePass" width="65" style={{ color: "red" }}>
                      {this.state.sTextPass}
                    </Col>
                  </Row>
                  <BlockTitle>
                    {" "}
                    {setLiteral(this.state.lsLiterales, "101032")}{" "}
                  </BlockTitle>
                  <Row className="aligner">
                    <Col id="charactes" width="65">
                      {setLiteral(this.state.lsLiterales, 101033)}
                    </Col>
                    <Col id="capital" width="65">
                      {setLiteral(this.state.lsLiterales, 101034)}
                    </Col>
                    <Col id="number" width="65">
                      {setLiteral(this.state.lsLiterales, 101035)}
                    </Col>
                  </Row>
                  <Block>
                    <Row className="aligner">
                      <Col
                        width="35"
                        xlarge="25"
                        large="25"
                        medium="25"
                        small="35"
                        xsmall="35"
                      >
                        <Button
                          fill
                          onClick={() => this.setState({ popupUser: false })}
                        >
                          {setLiteral(this.state.lsLiterales, 101071)}
                        </Button>
                      </Col>
                      <Col width="30"></Col>
                      <Col
                        width="35"
                        xlarge="25"
                        large="25"
                        medium="25"
                        small="35"
                        xsmall="35"
                      >
                        <Button fill onClick={this.insertUser}>
                          {setLiteral(this.state.lsLiterales, 101070)}
                        </Button>
                      </Col>
                    </Row>
                  </Block>
                </List>
              </Block>
            </Block>
          </Page>
        </Popup>

        {/* POPUP CAMBIO CONTRASEÑA  */}

        <Popup
          className="demo-popup"
          opened={this.state.popupPassword}
          onPopupClosed={() => this.setState({ popupPassword: false })}
        >
          <Page>
            <Navbar title={setLiteral(this.state.lsLiterales, 101031)}>
              <NavRight>
                <Link popupClose>X</Link>
              </NavRight>
            </Navbar>
            <Block>
              <Block>
                <form name="frmChangePass" id="frmChangePass">
                  <List noHairlinesMd>
                    <Row className="aligner">
                      <Col
                        width="90"
                        xlarge="65"
                        large="65"
                        medium="65"
                        small="90"
                        xsmall="90"
                      >
                        <ListInput
                          outline
                          label={setLiteral(this.state.lsLiterales, 101036)}
                          floatingLabel
                          type="text"
                          //maxlength="10"
                          onChange={(e) =>
                            this.setState({ username: e.target.value })
                          }
                          id="usernamePassword"
                          validate
                          required
                        >
                          <Icon
                            icon="person_alt_circle_fill"
                            f7="person_alt_circle_fill"
                            size="35"
                            slot="media"
                          />
                        </ListInput>
                      </Col>
                      <Col width="10"></Col>
                    </Row>
                    <Row className="aligner">
                      <Col
                        width="90"
                        xlarge="65"
                        large="65"
                        medium="65"
                        small="90"
                        xsmall="90"
                      >
                        <ListInput
                          outline
                          label={setLiteral(this.state.lsLiterales, 101037)}
                          floatingLabel
                          onChange={this.validatePassword}
                          type="password"
                          id="passChange1"
                          name="passChange1"
                          validate
                          required
                        >
                          <Icon
                            icon="lock_fill"
                            f7="lock_fill"
                            size="35"
                            slot="media"
                          />
                        </ListInput>
                      </Col>
                      <Col width="10">
                        <Button
                          id="btnShowPassChanger"
                          iconF7="eye_slash"
                          size="10"
                          onClick={() =>
                            this.showPassword(
                              "passChange1",
                              "btnShowPassChanger"
                            )
                          }
                        ></Button>
                      </Col>
                    </Row>
                    <Row className="aligner">
                      <Col
                        width="90"
                        xlarge="65"
                        large="65"
                        medium="65"
                        small="90"
                        xsmall="90"
                      >
                        <ListInput
                          outline
                          label={setLiteral(this.state.lsLiterales, 101039)}
                          floatingLabel
                          onChange={this.validateSamePass}
                          type="password"
                          id="passChange2"
                          validate
                          required
                        >
                          <Icon
                            icon="lock_fill"
                            f7="lock_fill"
                            size="35"
                            slot="media"
                          />
                        </ListInput>
                      </Col>
                      <Col width="10"></Col>
                      <Col id="samePass" width="65" style={{ color: "red" }}>
                        {this.state.sTextPass}
                      </Col>
                    </Row>
                    <BlockTitle>
                      {" "}
                      {setLiteral(this.state.lsLiterales, 101032)}{" "}
                    </BlockTitle>
                    <Row className="aligner">
                      <Col id="charactes" width="65">
                        {setLiteral(this.state.lsLiterales, 101033)}
                      </Col>
                      <Col id="capital" width="65">
                        {setLiteral(this.state.lsLiterales, 101034)}
                      </Col>
                      <Col id="number" width="65">
                        {setLiteral(this.state.lsLiterales, 101035)}
                      </Col>
                    </Row>
                    <Block>
                      <Row className="aligner">
                        <Col
                          width="35"
                          xlarge="25"
                          large="25"
                          medium="25"
                          small="35"
                          xsmall="35"
                        >
                          <Button
                            fill
                            onClick={() =>
                              this.setState({ popupPassword: false })
                            }
                          >
                            {setLiteral(this.state.lsLiterales, 101071)}
                          </Button>
                        </Col>
                        <Col width="30"></Col>
                        <Col
                          width="35"
                          xlarge="25"
                          large="25"
                          medium="25"
                          small="35"
                          xsmall="35"
                        >
                          <Button fill onClick={this.changePassword}>
                            {setLiteral(this.state.lsLiterales, 101041)}
                          </Button>
                        </Col>
                      </Row>
                    </Block>
                  </List>
                </form>
              </Block>
            </Block>
          </Page>
        </Popup>
      </Page>
    );
  }

  changeUser = (user) => {
    if (user.length > 10) {
      user = user.substring(0, 10);
    }

    this.setState({ username: user });
  };

  renderBlockOne = () => {
    return (
      <Block>
        <Row className="aligner">
          <Col width="100" medium="80" small="95">
            {/* height={this.state.heightFeatures} style={{ height: this.state.heightFeatures }} */}
            <div id="features" className="divSection rowflex elevation-15">
              <Row className="">
                <Col
                  width="100"
                  large="40"
                  medium="100"
                  small="100"
                  xsmall="100"
                >
                  <Row>
                    <Col width="100" className="aligner">
                      <h2>
                        {parse(setLiteral(this.state.lsLiterales, 101123))}
                      </h2>
                    </Col>
                  </Row>
                  <Row>
                    <Col width="100" className="aligner">
                      <div className="textCenter">
                        {parse(setLiteral(this.state.lsLiterales, 101124))}
                      </div>
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col width="100" className="aligner">
                      <Button
                        fill
                        onClick={(e) => this.setState({ popupRegistro: true })}
                      >
                        {parse(setLiteral(this.state.lsLiterales, 101028))}
                      </Button>
                    </Col>
                    <br />
                  </Row>
                </Col>
                <Col
                  width="100"
                  large="60"
                  medium="100"
                  small="100"
                  xsmall="100"
                >
                  <Row>
                    <Col width="100" className="aligner">
                      <List accordionList inset>
                        <ListItem
                          accordionItem
                          title={parse(
                            setLiteral(this.state.lsLiterales, 101125)
                          )}
                        >
                          <AccordionContent>
                            <Block>
                              <div>
                                {parse(
                                  setLiteral(this.state.lsLiterales, 101126)
                                )}
                                <br />
                                {parse(
                                  setLiteral(this.state.lsLiterales, 101104)
                                )}
                                <ul
                                  className="registerLi"
                                  style={{ paddingLeft: "2em" }}
                                >
                                  <li>
                                    {parse(
                                      setLiteral(this.state.lsLiterales, 101105)
                                    )}
                                  </li>
                                  <li>
                                    {parse(
                                      setLiteral(this.state.lsLiterales, 101106)
                                    )}
                                  </li>
                                  <li>
                                    {parse(
                                      setLiteral(this.state.lsLiterales, 101107)
                                    )}
                                  </li>
                                </ul>
                              </div>
                            </Block>
                          </AccordionContent>
                        </ListItem>
                        <ListItem
                          accordionItem
                          title={parse(
                            setLiteral(this.state.lsLiterales, 101109)
                          )}
                        >
                          <AccordionContent>
                            <Block>
                              <p>
                                {parse(
                                  setLiteral(this.state.lsLiterales, 101108)
                                )}{" "}
                                <b>
                                  {setLiteral(this.state.lsLiterales, 101004)}
                                </b>
                              </p>
                            </Block>
                          </AccordionContent>
                        </ListItem>
                      </List>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col
                  width="100"
                  large="40"
                  medium="100"
                  small="100"
                  xsmall="100"
                >
                  <Row>
                    <Col width="100" className="textCenter">
                      <h2>
                        {parse(
                          setLiteral(this.state.lsLiterales, 101013).replace(
                            "{producto}",
                            this.state.configMiApp.branch_name
                          )
                        )}
                      </h2>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      width="100"
                      className="aligner"
                      style={{ paddingLeft: "1em" }}
                    >
                      <div className="textCenter">
                        {parse(setLiteral(this.state.lsLiterales, 101110))}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col width="100" className="textCenter">
                      <div className="alternative-font">
                        {parse(setLiteral(this.state.lsLiterales, 101111))}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col width="50" className="aligner">
                      <ul className="aboutLi">
                        <li>
                          {parse(setLiteral(this.state.lsLiterales, 101112))}
                        </li>
                        <br />
                        <li>
                          {parse(setLiteral(this.state.lsLiterales, 101113))}
                        </li>
                      </ul>
                    </Col>
                    <Col width="50" className="aligner aboutLi">
                      <ul className="aboutLi">
                        <li>
                          {parse(setLiteral(this.state.lsLiterales, 101114))}
                        </li>
                        <br />
                        <li>
                          {parse(setLiteral(this.state.lsLiterales, 101115))}
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </Col>
                <Col
                  className="columSwiper"
                  width="100"
                  large="55"
                  medium="100"
                  small="100"
                  xsmall="100"
                >
                  <Swiper
                    effect="cube"
                    autoplay
                    speed={500}
                    spaceBetween={20}
                    height="300px"
                    style={{ height: "300px" }}
                  >
                    <SwiperSlide>.</SwiperSlide>
                    <SwiperSlide>.</SwiperSlide>
                    <SwiperSlide>.</SwiperSlide>
                    <SwiperSlide>.</SwiperSlide>
                  </Swiper>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Block>
    );
  };

  renderBlockTwo = () => {
    return (
      <Block id="blockAbout">
        <Row className="aligner">
          <Col width="100" medium="80" small="95">
            <div
              id="about"
              className="divSection rowflex elevation-15"
              height={this.state.height}
              style={{ height: this.state.height }}
            >
              <Row>
                <Col width="100" className="aligner">
                  <h1>
                    {" "}
                    {parse(
                      setLiteral(this.state.lsLiterales, 101016).replace(
                        "{producto}",
                        this.state.configMiApp.branch_name
                      )
                    )}{" "}
                  </h1>
                </Col>
              </Row>
              <Row className="aligner">
                <Col width="60" className="aligner labelPD">
                  {this.state.configMiApp.miapp_descriptionOne}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Block>
    );
  };

  renderBlockThree = () => {
    return (
      <ContactInformation
        lsLiterales={this.state.lsLiterales}
        configMiApp={this.state.configMiApp}
      />
    );
  };

  renderReferenciaUnica = () => {
    return this.state.companyReference === "436" ? (
      <ReferenciaUnicaConekta RU={this.state.RU} />
    ) : (
      <ReferenciaUnica RU={this.state.RU} />
    );
  };

  state = {
    height: 0,
    heightFeatures: 0,
    selectedTab: 1,
    username: "",
    password: "",
    hideEmail: "",
    loginScreenOpened: false,
    configDomain: "",
    configMiApp: "",
    lsLiterales: "",
    idEmpresa: "",
    popupRegistro: "",
    popupUser: false,
    bValidatePass: false,
    sPass: "",
    sTextPass: "",
    Identification: "",
    userInformation: "",
    bSamePass: false,
    popupPassword: false,
    showCloseLogin: "",
    RU: {},
    companyReference: "",
  };

  $$ = Dom7;
  f7router = "";

  caching = () => {
    let version = localStorage.getItem("version");
    if (version != packageJson.version) {
      if ("caches" in window) {
        caches.keys().then((names) => {
          // Delete all the cache files
          names.forEach((name) => {
            caches.delete(name);
          });
        });
        // Makes sure the page reloads. Changes are only visible after you refresh.
        window.location.reload(true);
      }

      localStorage.clear();
      localStorage.setItem("version", packageJson.version);
    }
  };

  componentDidMount = () => {
    const { f7route, f7router } = this.props;
    const params = f7route.query;

    if (params.page && params.page == "refunica") {
      console.log("AQUI")
      this.loadReferenciaUnica(params);
    } else {
      this.loadNormalMiapp(params);
    }

    this.caching();
  };

  loadNormalMiapp = (params) => {
    const { f7route, f7router } = this.props;

    const device = getDevice();
    if (device.android || device.ios) {
      //this.setState({ closeLogin: 'hide' });
    }

    if (window.innerWidth < 800 && this.props.reload) window.location.reload();

    this.f7router = f7router;

    const height = parseInt(window.innerHeight * 0.6) + "px";
    const heightFeatures = parseInt(window.innerHeight * 0.8) + "px";
    this.getConfiguration(params);
    this.setState({ height: height, heightFeatures: heightFeatures });
  };

  loadReferenciaUnica = async (params) => {
    if (params.companyid) {
      this.$$("body").addClass("color-theme-" + params.companyid);
      this.$$("body").addClass("ruStyle");
      await getTokens(parseInt(params.companyid));
    }

    f7.dialog.preloader();

    const method =
      "/core/Payment/PaymentReferenceUnique/" +
      params.contractid +
      "/" +
      params.companyid;
    let uniqueReference = await consumeApi("get", method, "");

    if (!String(uniqueReference).includes("error")) {
      if (params.companyid != "436")
        uniqueReference = uniqueReference.find(
          (item) =>
            item.provider.toUpperCase() === "ENEFEVO" ||
            item.provider.toUpperCase() === "CONEKTA"
        );
      this.setState({ RU: uniqueReference });
    }

    f7.dialog.close();

    this.setState({
      selectedTab: 5,
      companyReference: params.companyid,
    });
  };

  getConfiguration = async (params) => {
    const sHost = window.location.hostname;
    const method = "/security/InfoDomain/ConfigByDomain/" + sHost;

    const configuration = await consumeApi("GET", method, "");
    // configuration.id_empresa = "424";
    // configuration.id_idioma = "M";

    await getTokens(parseInt(configuration.id_empresa));

    this.$$("body").addClass("color-theme-" + configuration.id_empresa);

    this.setState({ configDomain: configuration });

    this.getLiterales();
    this.getConfigMiAppByBranch();

    if (
      params.company &&
      params.idpago &&
      params.idprovider &&
      params.email &&
      params.test
    ) {
      this.paymentOnline(
        params.company,
        params.idpago,
        params.idprovider,
        params.email,
        params.test
      );
    }

    if (this.props.f7route.query.IdCliente) {
      this.getUserByClientId(this.props.f7route.query.IdCliente);
    }
  };

  paymentOnline = async (company, paymentId, provider, email, test) => {
    const url =
      "/notification/Emails/CreateLinkPago/" +
      company +
      "/" +
      paymentId +
      "/" +
      provider +
      "/" +
      test +
      "/" +
      email +
      "/" +
      this.state.configDomain.id_idioma;

    const result = await consumeApi("GET", url, "");

    if (!result.includes("error")) {
      window.location.replace(result);
    } else if (result.includes("Invalid payment")) {
      f7.dialog.alert(
        "Su link de pago ya no es válido, favor de solicitar otro",
        "Link inválido"
      );
    }
  };

  selectTab = (e, tab) => {
    e.preventDefault();
    this.setState({ selectedTab: tab });
  };

  renderSection = (tab) => {
    switch (tab) {
      case 1:
      default:
        return <div></div>;
      case 2:
        return this.renderBlockOne();
      case 3:
        return this.renderBlockTwo();
      case 4:
        return this.renderBlockThree();
      case 5:
        return this.renderReferenciaUnica();
    }
  };

  dialogsignIn = (e) => {
    f7.dialog.login(
      "Ingresa datos",
      (username, password) => {
        this.validateUser(username, password);
      },
      (username, password) => {
        //boton de cancelar
      }
    );
  };

  getLiterales = async () => {
    f7.dialog.preloader(setLiteral(this.state.lsLiterales, 101030));
    const method =
      "/miapp/MiApp/Literal/" +
      this.state.configDomain.id_empresa +
      "/" +
      this.state.configDomain.id_idioma;

    const lsLiterales = await consumeApi("GET", method, "");
    this.setState({ lsLiterales: lsLiterales });
    f7.dialog.close();
  };

  getConfigMiAppByBranch = async () => {
    const method =
      "/miapp/MiApp/ConfigurationByBranch/" +
      this.state.configDomain.id_empresa;
    const lsLiterales = await consumeApi("GET", method, "");
    this.setState({ configMiApp: lsLiterales });
  };

  validateUser = async (username, password) => {
    const method = "/miapp/User/ValidateUser";

    if (validateEmail(username)) username = username.toUpperCase();

    const params = JSON.stringify({
      company: this.state.configDomain.id_empresa,
      login: username,
      password: password,
      applicationType: "1",
    });

    const login = await consumeApi("POST", method, params);

    if (login.clientId != "" && login.active == "1") {
      this.setState({ loginScreenOpened: false });

      this.f7router.navigate("/HomeInsdide/", {
        props: {
          lsLiterales: this.state.lsLiterales,
          user: login,
          configDomain: this.state.configDomain,
          configMiApp: this.state.configMiApp,
        },
      });
    } else if (login.active == "0") {
      this.setState({ userInformation: login });
      this.validateSMS();
    } else {
      if (login.includes("Not found data") || login.includes("error")) {
        f7.dialog.alert(setLiteral(this.state.lsLiterales, 101029), "");
      }
    }
  };

  validateIdentification = async (e) => {
    var bValida = false;
    if (e) {
      bValida = f7.input.validateInputs("#inIdentification");
    } else {
      bValida = true;
    }

    if (bValida) {
      f7.dialog.preloader(setLiteral(this.state.lsLiterales, 101030));
      const method =
        "/miapp/User/GetIdClienteByRFC/" +
        this.state.configDomain.id_empresa +
        "/" +
        this.state.Identification;

      var userId = await consumeApi("GET", method, "");

      if (!userId.includes("Not found data") || !userId.includes("error")) {
        userId = JSON.parse(userId);

        const method = "/miapp/User/UserData/";

        const params = JSON.stringify({
          company: this.state.configDomain.id_empresa,
          clientId: userId.IdCliente,
          option: "1",
          applicationType: "1",
        });

        const user = await consumeApi("POST", method, params);
        if (typeof user === "object" && user.clientId != "") {
          this.setState({
            popupRegistro: false,
            popupUser: false,
            Identification: "",
            userInformation: user,
          });
          f7.dialog.close();
          if (user.active == "1") {
            f7.dialog.alert(setLiteral(this.state.lsLiterales, 101094), "");
          } else {
            this.validateSMS();
          }
        } else if (user.includes("Not found data") || user.includes("error")) {
          const method = "/miapp/User/UserData/";

          const params = JSON.stringify({
            company: this.state.configDomain.id_empresa,
            clientId: userId.IdCliente,
            option: "3",
            applicationType: "1",
          });

          const user = await consumeApi("POST", method, params);
          user.clientId = userId.IdCliente;
          f7.dialog.close();

          let emailSplit = user.email.split("@");
          let starEmail = emailSplit[0].substring(0, 2);
          let finishEmail = emailSplit[0].substring(
            emailSplit[0].length - 2,
            emailSplit[0].length
          );
          let hideEmail =
            starEmail + "*****" + finishEmail + "@" + emailSplit[1];

          this.setState({
            popupRegistro: false,
            popupUser: true,
            userInformation: user,
            hideEmail: hideEmail,
            username: user.email,
          });
        }
      } else {
        f7.dialog.close();
        f7.dialog.alert(setLiteral(this.state.lsLiterales, 101069), "");
        this.setState({ Identification: "" });
      }
    }
  };

  showChangePass = (e) => {
    e.preventDefault();
    this.setState({
      popupPassword: true,
      loginScreenOpened: false,
      password: "",
    });
    this.$$("#capital").removeClass("charPass");
    this.$$("#number").removeClass("charPass");
    this.$$("#charactes").removeClass("charPass");
  };

  validatePassword = (e) => {
    e.preventDefault();
    const pass = e.target.value;
    var bCapital, bSpecial, bNumber, blength;

    if (capital(pass)) {
      this.$$("#capital").addClass("charPass");
      bCapital = true;
    } else {
      this.$$("#capital").removeClass("charPass");
      bCapital = false;
    }

    // if (specialChar(pass)) {
    //   this.$$("#specialChar").addClass('charPass');
    //   bSpecial = true;
    // }
    // else {
    //   this.$$("#specialChar").removeClass('charPass');
    //   bSpecial = false;
    // }

    if (digit(pass)) {
      this.$$("#number").addClass("charPass");
      bNumber = true;
    } else {
      this.$$("#number").removeClass("charPass");
      bNumber = false;
    }

    if (pass.length >= 8) {
      this.$$("#charactes").addClass("charPass");
      blength = true;
    } else {
      this.$$("#charactes").removeClass("charPass");
      blength = false;
    }

    this.setState({ sPass: pass });

    if (bCapital && bNumber && blength) {
      this.setState({ bValidatePass: true });
    }
  };

  validateSamePass = (e) => {
    if (e.target.value == this.state.sPass) {
      this.setState({ sTextPass: "", bSamePass: true });
    } else {
      this.setState({
        sTextPass: setLiteral(this.state.lsLiterales, 101043),
        bSamePass: false,
      });
    }
  };

  showPassword = (nameInput, nameButton) => {
    var input = this.$$('input[name="' + nameInput + '"]');
    if (input.attr("type") == "password") {
      input.attr("type", "text");
      this.$$("#" + nameButton + "")
        .children(".icon")
        .html("eye");
    } else {
      input.attr("type", "password");
      this.$$("#" + nameButton + "")
        .children(".icon")
        .html("eye_slash");
    }
  };

  insertUser = async () => {
    if (this.state.bValidatePass && this.state.bSamePass) {
      // 4 mandar validación sms
      var params = {
        company: this.state.configDomain.id_empresa,
        clientId: this.state.userInformation.clientId,
        name: this.state.userInformation.full_name,
        consecutive: "",
        failedAttempts: "0",
        email: this.state.userInformation.email,
        telephone: this.state.userInformation.personalPhone,
        option: "1",
        applicationType: "1",
      };

      f7.dialog.preloader();
      //1. ir por consecutivo opcion 1
      const method = "/miapp/User/InsertUser/";
      const resCons = await consumeApi("POST", method, JSON.stringify(params));
      if (!resCons.includes("error")) {
        var sCons = JSON.parse(resCons);
        const iCons = parseInt(sCons.IdConsecutivo) + 1;

        //2. insertar usuario con detalle opcion 5
        params.consecutive = String(iCons);
        params.option = "5";
        const insFullUser = await consumeApi(
          "POST",
          method,
          JSON.stringify(params)
        );

        if (typeof insFullUser == "object") {
          const methodUpdate = "/miapp/User/UpdateUser/";

          params = JSON.stringify({
            company: this.state.configDomain.id_empresa,
            clientId: this.state.userInformation.clientId,
            login: this.state.username,
            password: this.state.sPass,
            option: "1",
            applicationType: "1",
          });

          const insLogin = await consumeApi("POST", methodUpdate, params);
          if (!insLogin.includes("error")) {
            this.sendSMS(insFullUser.telephone);
          } else {
            f7.dialog.close();
            f7.dialog.alert("Error");
          }
        } else {
          f7.dialog.close();
          f7.dialog.alert("Error");
        }
      } else {
        f7.dialog.close();
        f7.dialog.alert("Error");
      }
    }
  };

  sendSMS = async (telephone) => {
    f7.dialog.preloader("");

    const method =
      "/core/Contract/ContractByClientId/" +
      this.state.configDomain.id_empresa +
      "/" +
      this.state.userInformation.clientId;
    const contracts = await consumeApi("get", method, "");

    var nup = "";

    if (typeof contracts == "object" && contracts.length > 0) {
      contracts[0].contractCode;
      nup = contracts[0].contractCode.split("N")[1];
    }

    const methodPass = "/miapp/User/SmsSend";
    const params = JSON.stringify({
      company: this.state.configDomain.id_empresa,
      language: this.state.configDomain.id_idioma,
      clientId: this.state.userInformation.clientId,
      login: this.state.userInformation.login,
      telephone: telephone,
      typeSms: "2",
      application_id: nup,
      applicationType: "1",
    });

    const insSms = await consumeApi("POST", methodPass, params);
    f7.dialog.close();
    if (!insSms.includes("error")) {
      this.validateSMS();
    }
  };

  validateSMS = async () => {
    f7.dialog
      .create({
        title: setLiteral(this.state.lsLiterales, 101053),
        text:
          "<div>" +
          setLiteral(this.state.lsLiterales, 101054) +
          ' </br><div class="textCenter">' +
          setLiteral(this.state.lsLiterales, 101055) +
          '</div><input id="inSMS" type="text" class="dialog-input"></input>' +
          "</div>",
        buttons: [
          {
            text: setLiteral(this.state.lsLiterales, 101060),
            onClick: async () => {
              if (Dom7("#inSMS").val() == "") {
                f7.dialog.alert(setLiteral(this.state.lsLiterales, 101061), "");
                this.validateSMS();
              } else {
                const value = Dom7("#inSMS").val();

                const methodValidate = "/miapp/User/CustomerBySms";

                const params = JSON.stringify({
                  company: this.state.configDomain.id_empresa,
                  clientId: this.state.userInformation.clientId,
                  sms: value,
                  option: "2",
                  applicationType: "1",
                });

                const insSms = await consumeApi("POST", methodValidate, params);
                if (!insSms.includes("error")) {
                  const methodActive = "/miapp/User/UpdateSmsUser";

                  const params = JSON.stringify({
                    company: this.state.configDomain.id_empresa,
                    clientId: this.state.userInformation.clientId,
                    sms: value,
                    status: "1",
                    applicationType: "1",
                  });

                  const activeSms = await consumeApi(
                    "POST",
                    methodActive,
                    params
                  );
                  if (!activeSms.includes("error")) {
                    this.setState({
                      loginScreenOpened: true,
                      popupUser: false,
                      popupPassword: false,
                    });
                  }
                } else {
                  f7.dialog.alert(
                    setLiteral(this.state.lsLiterales, 101056),
                    ""
                  );
                  this.validateSMS();
                }
              }
            },
          },
          {
            text: setLiteral(this.state.lsLiterales, 101097),
            onClick: () => {
              var tel = "";
              if (this.state.userInformation.personalPhone)
                tel = this.state.userInformation.personalPhone;
              else if (this.state.userInformation.telephone)
                tel = this.state.userInformation.telephone;

              this.sendSMS(tel);
            },
          },
        ],
      })
      .open();
  };

  changePassword = async () => {
    if (f7.input.validateInputs("#frmChangePass")) {
      if (this.state.bValidatePass && this.state.bSamePass) {
        let username = this.state.username;

        if (validateEmail(username)) username = username.toUpperCase();

        f7.dialog.preloader(setLiteral(this.state.lsLiterales, 101030));

        const mValidateLogin = "/miapp/User/LoginExistent";
        const params = JSON.stringify({
          company: this.state.configDomain.id_empresa,
          login: username,
          applicationType: "1",
        });

        const validateUser = await consumeApi("POST", mValidateLogin, params);

        if (typeof validateUser == "object") {
          const updUser = "/miapp/User/UpdateUser";
          const params = JSON.stringify({
            company: this.state.configDomain.id_empresa,
            login: username,
            clientId: validateUser.clientId,
            password: this.state.sPass,
            option: "2",
            applicationType: "1",
          });
          var updateUser = await consumeApi("POST", updUser, params);

          if (!updateUser.includes("error")) {
            f7.dialog.close();
            this.setState({ userInformation: validateUser });
            this.sendSMS(validateUser.telephone);
          } else {
            f7.dialog.close();
            f7.dialog.alert(setLiteral(this.state.lsLiterales, 102003), "");
          }
        } else {
          f7.dialog.close();
          f7.dialog.alert(setLiteral(this.state.lsLiterales, 101050), "");
        }
      } else {
      }
    }
  };

  getUserByClientId = async (clientId) => {
    const mGetCliente =
      "/core/Customer/CustomerByClientId/" +
      this.state.configDomain.id_empresa +
      "/" +
      clientId;
    const getClient = await consumeApi("GET", mGetCliente, "");

    if (typeof getClient != "string" && !getClient.includes("error")) {
      this.setState({ Identification: getClient[0].identificationUnique });
      this.validateIdentification(null);
    } else {
      f7.dialog.alert(setLiteral(this.state.lsLiterales, 101050), "");
    }
  };
}
